export default {
  HIDE_IOS_WIDGETS_MESSAGE: 'hideCloseButtonAndNativePanel',
  SHOW_IOS_WIDGETS_MESSAGE: 'showCloseButtonAndNativePanel',
};
